import axios from 'axios'
import store from '../store'

const customAxios = axios.create()

customAxios.interceptors.request.use((config) => {
  const {access_token} = store.state
  const {apiBase} = store.state.settings

  config.baseURL = apiBase 
  config.headers['Authorization'] = `Bearer ${access_token}`

  return config
})

customAxios.interceptors.response.use(async response => {
  return response;
}, async error => {
  if (error.response.status === 401) {
    store.commit('unAuthLogout')
  }

  return Promise.reject(error);
});

export default customAxios